// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"91a26d1c","373":"8ee42116","447":"3cef2062","478":"ea905cfa","748":"c764596d","942":"929ccb7c"}[chunkId] + ".chunk.js";
};